<script>
  import { Router, Route, Link, link } from "svelte-routing";
  // import { Router, Link, Route, link } from "svelte-navigator";
  // Used for SSR. A falsy value is ignored by the Router.
  // export let url = "";
  import FollowingButton from './FollowingButton.svelte';
  // import { createEventDispatcher } from 'svelte';

  // const dispatch = createEventDispatcher();
  
  import { isDisplayIssue, whenLast, listId, newsletterId } from './stores.js';
  import {shortDate} from  './helpers.js';
  
  export let isPaidVersion = false;
  export let expand="nochange";  // nochange|expand|contract
  export let toc = ["loading_1587651476||Loading||Loading TOC"]
  let tocObj = {};
  let readObj = JSON.parse(localStorage.getItem('readObj'));
  if (readObj==null){readObj={}};

  const displayPage2 = function(){
    console.log('@CardTOC in displayPage2 newsletterId='+$newsletterId);
    //below scroll both to the top
    document.body.scrollTop = 0; // For Safari
    document.getElementById('recontent').scrollTop = 0;
    isDisplayIssue.set(true)
  }

  const isLatest = function(x){ //used to highlight newsletters since whenLast
    if ($whenLast>x.split('_')[1]){return false}
    // unreadCount.update(n => n + 1);
    // newCount.update(m => m + 1);
    // console.log ("isLatest="+x+"  $whenLast="+$whenLast)
    return true;
  }
  
  const buildTocObj= function(tocEntry){
    tocObj={};
    tocObj.id=tocEntry.split("||")[0];
    tocObj.email=tocObj.id.split("_")[0];
    tocObj.from=tocEntry.split("||")[2];
    if (tocObj.from){
      tocObj.from=tocObj.from.replace(/"/gi, '')
    }
    tocObj.subject=tocEntry.split("||")[1];
    tocObj.seconds=tocEntry.split("||")[0].split("_")[1];
    tocObj.pubDate=new Date(tocObj.seconds*1000).toString().substr(0,15)
    tocObj.pubDay=tocObj.pubDate.substr(0,3);  //Sun, Mon, Tue, Wed, Thu, Fri, Sat
    tocObj.isOld=((tocObj.seconds*1000)+ 5211216162 < new Date().getTime());
    return tocObj;
  }
  
  const buildTocObjs = function(toc){
    return toc.map(x => buildTocObj(x));
  }
  let tocObjs = buildTocObjs(toc);

  //=========== display (first) article if no article is displayed
  // console.log('@CardTOC newsletterId='+$newsletterId+"   id="+tocObjs[0].id);
  if ($newsletterId == 0 && $listId !==0){
    console.log('@CardTOC newsletterId='+$newsletterId+"   id="+tocObjs[0].id);
    newsletterId.set(tocObjs[0].id)
  }

  

  let marker="+";
  if (expand=="expand"){
    marker="-";
  } else if (expand=="contract"){
    marker="+";
  }
  const showBackissues = function(){
    //alert('marker='+marker);
    if (marker=="-"){ //close
      marker="+"
    }else{ //expand
      marker="-"
    }
  }
  console.log("@CardTOC.svelte")
</script>
<div class="card">
  <div class="from">{tocObjs[0].from} 
    <span class="remaining"></span>
    <span class="followbutton"><FollowingButton publisherId="{tocObj.email}"></FollowingButton></span>
  </div>
    {#each tocObjs as obj, index}
      {#if index==0 || marker=="-"}
        <div class="markerdatesubject" id="{obj.id}">
          <!-- <Router> -->
            <span class="marker" on:click={showBackissues}>
              {#if index==0}
                &nbsp;[{marker}]&nbsp;
              {/if}
            </span>
            <span class="showdate">
              <a  class:sincelast={isLatest(obj.id)} href="/newsletter/{obj.id}" >{shortDate(obj.seconds)}</a>
            </span>
            <a class="subject" href="/newsletter/{obj.id}" on:click={displayPage2} use:link>{obj.subject}</a>
          <!-- </Router> -->
        </div>
        {#if isPaidVersion && index==0}
          <div class="markerdatesubject isPaidVersion">
            <span></span>
            <span></span>
            <span>&mdash; Publisher offers an expanded paid version</span>
          </div>
        {/if}
      {/if}
    {/each}   
  </div>

<style>
  .markerdatesubject{padding-left: 0rem; padding-top: 0.3em; padding-bottom:0.3em;
    display: grid; grid-template-columns: 2em 4.5em 1fr; color: black;}
  .marker {text-align: center; }
  .markerdatesubject:hover {background-color: lightblue; text-decoration: underline; color: CornflowerBlue;}
  .sincelast {color: forestgreen; font-weight: bold;}
  .subject a:visited, .isPaidVersion {color: gray; }
  .card {margin: 0.5rem; display: grid; grid-template-columns: 1fr;}
  .from {font-weight: bold; font-size: 1.4rem;}
  .isPaidVersion {text-decoration: none;}
  .followbutton {font-size: 0.9rem; padding-left: 0.25rem;}
  /* .datesubject, .datesubject a, .datesubject span  {color: forestgreen}
  .datasubject:visited {color:red;} */

</style>

